<template lang="pug">
	.campaign-product.flex-col.space-medium(v-if="products && products.length")
		.flex-row.space.align-center(v-if="!product.type.multiple")
			fas(:icon="product.type.icon", size="2xl")
			EditableLabel(ref="productNameLabel", :disabled="info.readonly")
				.font-big {{product.Name}}
				template(slot="editor")
					DxTextBox(:value.sync="product.Name", @value-changed="$refs.productNameLabel.release()")
			DxButton(v-if="!info.readonly", icon="close", stylingMode="text", @click="deleteProduct(product)")
			Loader(v-if="isLoading", text="")
		CampaignAirtime(v-if="product.type.id === 2", :info="info", :product="product")
		template(v-for="prod in products")
			.flex-row.space.align-center(v-if="product.type.multiple")
				fas(:icon="prod.type.icon", size="2xl")
				EditableLabel(:ref="`productNameLabel_${prod.Oid}`", :disabled="info.readonly")
					.font-big {{prod.Name}}
					template(slot="editor")
						DxTextBox(:value.sync="prod.Name", @value-changed="$refs[`productNameLabel_${prod.Oid}`][0].release()")
				DxButton(v-if="!info.readonly", icon="close", stylingMode="text", @click="deleteProduct(prod)")
				Loader(v-if="isLoading", text="")
			.campaign-tab(v-if="prod.type.hasPodcasts")
				.flex-row
					.tab-title.font-tiny.upper.grey {{$tCaption('Podcast')}}
				.tab-content
					CampaignPodcasts(:info="info", :product="prod", @change="onProductsChange")
			.campaign-tab(v-if="isStreamingsVisible(prod)")
				.flex-row
					.tab-title.font-tiny.upper.grey {{$tCaption('Streaming')}}
				.tab-content
					CampaignStreamings(:info="info", :product="prod", @change="onProductsChange")
		.flex-row.align-center.center(v-if="product.type.multiple")
			DxButton(v-if="!info.readonly", :text="$tCaption('Add more')", @click="$emit('new-product', product.DapCategory)", icon="plus")
</template>

<script>
	import _ from 'lodash';
	import EditableLabel from 'app-core/EditableLabel.vue';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';
	import CampaignPodcasts from './CampaignPodcasts.vue';
	import CampaignStreamings from './CampaignStreamings.vue';
	import CampaignAirtime from './CampaignAirtime.vue';

	export default {
		translationCategory: 'campaign.Detail.Product',
		name: 'campaign-product',
		components: {
			EditableLabel, DxTextBox, Loader, DxButton, CampaignPodcasts, CampaignStreamings, CampaignAirtime
		},
		props: ['info', 'active', 'products'],
		data() {
			return {
				isLoading: false,
				isProductAssigning: false
			};
		},
		computed: {
			campaign() {
				return this.info?.campaign;
			},
			campaignProducts() {
				return this.info?.campaignProducts;
			},
			product() {
				return this.products && this.products[0];
			}
		},
		watch: {
		},
		mounted() {
			if (__DEBUG__)
				window.campaignProduct = this;
		},
		destroyed() {
		},
		methods: {
			onProductsChange(product) {
				if (this.isProductAssigning) return;
				if (this.products.find(f => f.Oid === product.Oid)) {
					this.updateProduct(product);
				}
			},
			isStreamingsVisible(prod) {
				return prod.DapCategory.IsStreamingSupported && (!prod.type.hasPodcasts || this.product.Podcast);
			},
			updateProduct(product) {
				this.isLoading++;
				this.$Data.postExternalApi('CampaignProduct/CreateUpdateCampaignProduct', product).then(r => {
					if (r?.Data) {
						this.isProductAssigning = true;
						_.assign(product, r?.Data);
						setImmediate(() => this.isProductAssigning = false);
					}
				}).finally(() => this.isLoading--);
			},
			deleteProduct(product) {
				this.$confirmMessage({
					title: () => this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Are you sure you want to delete product?'),
					handler: () => {
						this.isLoading++;
						this.$Data.postExternalApi('CampaignProduct/DeleteCampaignProducts', [product.Oid]).then(r => {
							if (r.Success) {
								this.$notifySuccess(this.$tCaption('Product deleted'));
								this.$emit('product-removed', product);
							}
						}).finally(() => {
							if (this._isDestroyed) return;
							this.isLoading--;
						});
					}
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.campaign-product {
		
	}
</style>
 